var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoIconWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C9.62663 0 7.30655 0.674463 5.33316 1.9381C3.35977 3.20174 1.8217 4.99779 0.913451 7.09914C0.00519943 9.20049 -0.232441 11.5128 0.230582 13.7435C0.693605 15.9743 1.83649 18.0234 3.51472 19.6317C5.19295 21.24 7.33115 22.3353 9.65892 22.779C11.9867 23.2228 14.3995 22.995 16.5922 22.1246C18.7849 21.2542 20.6591 19.7802 21.9776 17.8891C23.2962 15.9979 24 13.7745 24 11.5C23.9989 8.45032 22.7343 5.52584 20.4841 3.36939C18.2339 1.21295 15.1823 0.00101605 12 0ZM13.2 17.25H10.8V14.95H13.2V17.25ZM13.2 12.65H10.8V5.75H13.2V12.65Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIconWhite);
export default __webpack_public_path__ + "static/media/info-icon-white.9e450fd4909b901fd73cbf6eed565da4.svg";
export { ForwardRef as ReactComponent };